import { createFileRoute } from '@tanstack/react-router';
import { SuperAdmins } from '@/features/plataforma/componentes/SuperAdmins';
import { rotaDaPlataforma } from '@/features/permissoes/guardas';

/** Super-admins da plataforma: lista, convite e reenvio. */
export const Route = createFileRoute('/_autenticado/plataforma/super-admins')({
  ...rotaDaPlataforma('Super-admins'),
  component: SuperAdmins,
});
